/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { generateDocsUrl } from '../../ia/util/docs';

export const links = {
  BYOSD_LINK:
    'https://github.com/watson-developer-cloud/assistant-web-chat-service-desk-starter',
  GENESYS_BYOSD_LINK:
    'https://web-chat.global.assistant.watson.cloud.ibm.com/docs.html?to=service-desks-genesys',
  NICE_INCONTACT_LINK:
    'https://web-chat.global.assistant.watson.cloud.ibm.com/docs.html?to=service-desks-nice',
  ORACLE_LINK:
    'https://github.com/watson-developer-cloud/assistant-web-chat-service-desk-starter/tree/main/src/oracle/webChat',
  TWILIO_BYOSD_LINK:
    'https://github.com/watson-developer-cloud/assistant-web-chat-service-desk-starter/tree/main/src/flex/webChat',
  KUSTOMER_BYOSD_LINK:
    'https://github.com/watson-developer-cloud/assistant-web-chat-service-desk-starter/tree/main/src/kustomer/webChat',
  EGAIN_LINK:
    'https://github.com/watson-developer-cloud/assistant-web-chat-service-desk-starter/tree/main/src/egain/webChat',
  ENGHOUSE_LINK:
    'https://github.com/watson-developer-cloud/assistant-web-chat-service-desk-starter/tree/main/src/enghouse',
  WEBCHAT_TILE_LEARN_MORE_CLASSIC: generateDocsUrl(
    '/?topic=assistant-web-chat-basics'
  ),
  WEBCHAT_TILE_LEARN_MORE_NEW_IA: generateDocsUrl(
    '/?topic=watson-assistant-web-chat-overview'
  ),
  PHONE_TILE_LEARN_MORE_CLASSIC: generateDocsUrl(
    '/?topic=assistant-deploy-phone'
  ),
  PHONE_TILE_LEARN_MORE_NEW_IA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-phone'
  ),
  BYOS_LEARN_MORE:
    'https://medium.com/ibm-watson/bring-your-own-search-to-ibm-watson-assistant-587e77410c98'
};
